import { render, staticRenderFns } from "./LiveStreamIcon.vue?vue&type=template&id=a00fdfac&"
import script from "./LiveStreamIcon.vue?vue&type=script&lang=js&"
export * from "./LiveStreamIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports